export interface PhotoBarCallbacks {
  onOrbit(dx: number, dy: number): void;
  onZoom(deltaY: number): void;
  onCapture(): void;
  onExit(): void;
}

/** Lapisan mode foto: seret memutar, scroll zoom, jepret PNG, keluar. */
export class PhotoBar {
  private layer: HTMLDivElement;
  private dragging = false;
  private lastX = 0;
  private lastY = 0;
  private cb: PhotoBarCallbacks;

  private onMouseDown = (e: MouseEvent): void => {
    if (e.button !== 0) return;
    if ((e.target as HTMLElement).closest('button')) return;
    this.dragging = true;
    this.lastX = e.clientX;
    this.lastY = e.clientY;
    this.layer.style.cursor = 'grabbing';
  };

  private onMouseMove = (e: MouseEvent): void => {
    if (!this.dragging) return;
    this.cb.onOrbit(e.clientX - this.lastX, e.clientY - this.lastY);
    this.lastX = e.clientX;
    this.lastY = e.clientY;
  };

  private onMouseUp = (): void => {
    this.dragging = false;
    this.layer.style.cursor = 'grab';
  };

  private onWheel = (e: WheelEvent): void => {
    e.preventDefault();
    this.cb.onZoom(e.deltaY);
  };

  constructor(container: HTMLElement, cb: PhotoBarCallbacks) {
    this.cb = cb;
    this.layer = document.createElement('div');
    this.layer.style.cssText =
      'position:absolute;inset:0;pointer-events:auto;cursor:grab;z-index:4;';
    const bar = document.createElement('div');
    bar.style.cssText =
      'position:absolute;left:50%;bottom:18px;transform:translateX(-50%);' +
      'display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:12px;' +
      'background:rgba(10,10,15,0.78);border:1px solid rgba(255,255,255,0.14);' +
      'color:#e8e8ef;font-family:system-ui,sans-serif;font-size:13px;white-space:nowrap;';
    const label = document.createElement('span');
    label.style.cssText = 'letter-spacing:2px;font-weight:700;';
    label.textContent = 'MODE FOTO';
    bar.appendChild(label);
    const hint = document.createElement('span');
    hint.style.cssText = 'opacity:0.6;font-size:12px;';
    hint.textContent = 'Seret: putar · Scroll: zoom · P: keluar (game tetap jalan)';
    bar.appendChild(hint);
    const snap = document.createElement('button');
    snap.textContent = 'AMBIL FOTO';
    snap.style.cssText =
      'padding:8px 16px;font-size:13px;font-weight:700;color:#0a0a0f;' +
      'background:#5dffd4;border:none;border-radius:8px;cursor:pointer;';
    snap.onclick = () => this.cb.onCapture();
    bar.appendChild(snap);
    const exit = document.createElement('button');
    exit.textContent = 'KELUAR';
    exit.style.cssText =
      'padding:8px 16px;font-size:13px;color:#e8e8ef;background:transparent;' +
      'border:1px solid rgba(232,232,239,0.35);border-radius:8px;cursor:pointer;';
    exit.onclick = () => this.cb.onExit();
    bar.appendChild(exit);
    this.layer.appendChild(bar);
    container.appendChild(this.layer);

    this.layer.addEventListener('mousedown', this.onMouseDown);
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('mouseup', this.onMouseUp);
    this.layer.addEventListener('wheel', this.onWheel, { passive: false });
  }

  dispose(): void {
    this.layer.removeEventListener('mousedown', this.onMouseDown);
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
    this.layer.removeEventListener('wheel', this.onWheel);
    this.layer.remove();
  }
}
